import React, { useState } from 'react';

import { Typography, IconButton, Collapse } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Alert from '@material-ui/lab/Alert';

import { Icon } from '@hydra/common/components';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(2.5),
    borderRadius: theme.shape.borderRadius * 2.5
  },
  title: {
    fontWeight: theme.typography.fontWeightSemibold,
    marginBottom: theme.spacing(0.5),
    display: 'block'
  },
  dismissButton: {
    alignSelf: 'flex-start'
  }
}));

interface NotificationBannerProps {
  icon?: React.ReactNode | boolean
  severity?: 'info' | 'success' | 'warning' | 'error'
  variant?: 'filled' | 'outlined'
  dismissable?: boolean
  children?: React.ReactNode
  title?: string | React.ReactNode
  description?: string | React.ReactNode
  classes?: {}
}

export default function NotificationBanner ({
  icon = false,
  severity = 'info', // info | success | warning | error
  variant = 'filled', // outlined | filled
  dismissable = false,
  children,
  title,
  description,
  classes: customClasses
}: NotificationBannerProps) {
  const [open, setOpen] = useState(true);
  const classes = useStyles();
  return (
    <Collapse in={open}>
      <Alert
        severity={severity}
        variant={variant}
        className={classes.root}
        icon={icon}
        classes={customClasses}
        action={dismissable && (
          <IconButton
            aria-label='close'
            color='inherit'
            size='small'
            className={classes.dismissButton}
            onClick={() => {
              setOpen(false);
            }}
          >
            <Icon type='cross' size='sm' />
          </IconButton>
        )}
      >
        <>
          {title && (
            <Typography component='span' className={classes.title}>
              {title}
            </Typography>
          )}
          {description && (
            <Typography component='span'>
              {description}
            </Typography>
          )}
          {children}
        </>
      </Alert>
    </Collapse>
  );
}
